import path from 'node:path';
import { randomUUID } from 'node:crypto';
import camelCase from 'lodash/camelCase.js';
import { componentGenerator } from '@wix/gena';
import type { SupportedServicePlugin } from '@wix/cli-app-definitions';
import { getBackendPluginExtensionPath } from '@wix/cli-astro-definitions';
import { modifyExtensionsEntry } from '@wix/cli-project-extender';
import { getExtensionRelativePaths } from '../utils/extension-relative-paths.js';

// NOTE: path is relative to the build folder
const SERVICE_PLUGIN_TEMPLATE = path.resolve(
  __dirname,
  '../templates/astro/service-plugin'
);

export async function generateServicePlugin(
  projectFolder: string,
  servicePluginType: SupportedServicePlugin,
  route: string
) {
  const cwd = getBackendPluginExtensionPath(projectFolder, route);
  const { relativePathToCodeFile, relativePathToConfigFile } =
    getExtensionRelativePaths({
      cwd,
      projectFolder,
      extensionFileName: route,
      codeFileType: 'ts',
    });

  const config = {
    id: randomUUID(),
    source: relativePathToCodeFile,
  };

  const servicePluginTypeLower = servicePluginType
    .toLowerCase()
    .replaceAll('_', '-');

  await modifyExtensionsEntry(
    projectFolder,
    camelCase(route),
    relativePathToConfigFile
  );

  return await componentGenerator({
    template: path.join(SERVICE_PLUGIN_TEMPLATE, servicePluginTypeLower),
    projectFolder,
    cwd,
    data: {
      route,
      config,
    },
  });
}
